// extracted by css-extract-rspack-plugin
export default {"CommentActionsIconButton":"CommentActions-module__CommentActionsIconButton__sKptGw1","CommentActionsListItem":"CommentActions-module__CommentActionsListItem__Viwlyny"};